import React from 'react';
import './DigitalCTA.css';

const DigitalCTA = () => {
  const handleScheduleClick = () => {
    // En una implementación real, aquí se redirigiría a la plataforma de agendamiento
    alert('Redirigiendo a la plataforma de agendamiento digital...');
  };

  return (
    <section className="digital-cta">
      <div className="container">
        <div className="cta-content">
          <div className="cta-background">
            <div className="floating-elements">
              <div className="floating-element element-1">📱</div>
              <div className="floating-element element-2">⚡</div>
              <div className="floating-element element-3">🚀</div>
              <div className="floating-element element-4">✨</div>
            </div>
          </div>

          <div className="cta-text">
            <h2 className="cta-title">
              ¡Agenda tu asistencia ahora!
            </h2>
            <p className="cta-subtitle">
              Accede a nuestra plataforma digital y solicita tu multiasistencia en minutos.
              Rápido, fácil y disponible las 24 horas.
            </p>
            <div className="cta-features">
              <div className="feature-item">
                <span className="feature-icon">⚡</span>
                <span>Proceso rápido</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🔒</span>
                <span>100% seguro</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">📱</span>
                <span>Desde cualquier dispositivo</span>
              </div>
            </div>
          </div>

          <div className="cta-action">
            <a href='https://galicia.dspigs.com/' target="_blank" rel="noopener noreferrer" className="btn-link">
              <button
                className="btn btn-cta"
              >
                <span className="btn-text">Agendar Digitalmente</span>
                <span className="btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
            </a>
            <p className="cta-note">
              * Disponible 24/7 para tu comodidad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalCTA;